import { useState } from 'react';
import { Mail, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { sendDigestMeWeekly, sendDigestMeMonthly } from '../../lib/api';

/**
 * Bottone "Invia digest ora" per il digest settimanale o mensile.
 *
 * Chiama l'endpoint autenticato `/api/email/me/{weekly|monthly}` che invia
 * SOLO all'utente corrente — niente token interno, niente cron.
 *
 * Props:
 *   - kind: 'weekly' | 'monthly'
 *   - testid: data-testid del bottone
 */
export default function SendDigestButton({ kind = 'weekly', testid }) {
  const [busy, setBusy] = useState(false);

  const label = kind === 'monthly' ? 'Invia digest mensile' : 'Invia digest settimanale';
  const sender = kind === 'monthly' ? sendDigestMeMonthly : sendDigestMeWeekly;

  const click = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const res = await sender();
      const first = (res?.results && res.results[0]) || {};
      if (first.error) {
        toast.error(`Invio fallito · ${first.error}`);
      } else if (first.skipped) {
        toast.info(`Nessun dato per ${kind === 'monthly' ? 'il mese' : 'la settimana'} chiusi`);
      } else {
        toast.success('Email inviata', {
          description: first.email ? `→ ${first.email}` : undefined,
        });
      }
    } catch (e) {
      toast.error(`Errore · ${e?.response?.data?.detail || e?.message || 'sconosciuto'}`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={click}
      disabled={busy}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-line text-soft hover:border-ink hover:text-ink font-mono text-[10px] uppercase tracking-[0.18em] transition-colors disabled:opacity-50 disabled:cursor-wait"
      data-testid={testid || `send-${kind}-digest-btn`}
      title={label}
    >
      {busy ? <Loader2 size={12} strokeWidth={1.5} className="animate-spin" /> : <Mail size={12} strokeWidth={1.5} />}
      {busy ? 'Invio…' : 'Invia email'}
    </button>
  );
}
